export default "__VITE_ASSET__Cg3yazbS__"